import { InstallationInDb } from '@/db/db'
import { mightFail } from 'might-fail'

export const s3UploadInstallationFile = async ({
  presignedUrl,
  file
}: {
  presignedUrl: string
  file: NonNullable<InstallationInDb['file']>
}) => {
  // Convert ArrayBuffer to Blob
  const blob = new Blob([file], { type: 'application/json' })

  const { error: networkError, result: response } = await mightFail(
    fetch(presignedUrl, {
      method: 'PUT',
      body: blob,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  )

  if (networkError) {
    console.error('s3UploadInstallationFile network error', networkError.message)
    return null
  }

  if (!response.ok) {
    console.log('s3UploadInstallationFile Error response from server', response)
    return null
  }

  // S3 doesn't return JSON for a successful upload, so we don't need to parse the response
  // Instead, we can construct the URL from the presigned URL
  const src = presignedUrl.split('?')[0]

  if (!src) {
    console.log('Could not extract result URL for s3UploadInstallationFile', presignedUrl)
    return null
  }

  return src
}
